import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabSelector from '../components/tabSelector/TabSelector';
import ListUsersComponent from '../components/admin-panel/users/ListUsers';
import ListSummariesComponent from '../components/admin-panel/summaries/ListSummaries';
import AddUserComponent from '../components/forms/AddUserForm';
import CreateTest from '../components/admin-panel/tests/createTest/CreateTest';
import ListTestComponent from '../components/admin-panel/tests/listTest/ListTest';
import ListQuestionComponent from '../components/admin-panel/questions/listQuestions';
import UploadQuestionComponent from '../components/admin-panel/questions/uploadQuestions';
import ListReportQuestions from '../components/admin-panel/reports/listReportOption';
import TabsDisplay from '../components/admin-panel/TabsDisplay';


export default function AdminPanelView(): JSX.Element {

  const history = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const firstRun = useRef(true);
  const TABS = [
    {
      id: 'test',
      label: 'Tests',
      tabs: [
        { id: 'list', label: 'Listar tests', component: <ListTestComponent/> },
        { id: 'create', label: 'Crear tests', component: <CreateTest/> },
      ]
    },
    {
      id: 'questions',
      label: 'Preguntas',
      tabs: [
        { id: 'list', label: 'Listar preguntas', component: <ListQuestionComponent/> },
        { id: 'upload', label: 'Subir CSV', component: <UploadQuestionComponent/> },
      ]
    },
    {
      id: 'reports',
      label: 'Reportes',
      tabs: [
        { id: 'list', label: 'Listar reportes', component: <ListReportQuestions/> },
      ]
    },
    {
      id: 'users',
      label: 'Usuarios',
      tabs: [
        { id: 'list', label: 'Lista de usuarios', component: <ListUsersComponent/> },
        { id: 'create', label: 'Crear usuario', component: <AddUserComponent/> },
      ]
    },
    {
        id: 'summary',
        label: 'Resumen',
        tabs: [
            { id: 'list', label: 'Resumen de actividad por norma', component: <ListSummariesComponent/> },
        ]
    }
  ];

  const [activeTab, setActiveTab] = useState('test');

  function updateUrlWithState() {
    history({ search: new URLSearchParams({ tab: activeTab }).toString() });
  }

  useEffect(() => {
    const tab = params.get('tab');
    if (tab && TABS.some(t => t.id === tab)) {
      setActiveTab(tab);
    } else {
      updateUrlWithState();
    }
  }, []);

  useEffect(() => {
    updateUrlWithState();
  }, [activeTab]);

  return (
    <div className='flex-1 flex flex-col overflow-hidden'>
      <TabSelector tabs={TABS} activeTab={activeTab} onChange={(tab) => { setActiveTab(tab); }} />
      { TABS.map(tab => (
        <div className={`flex-1 overflow-hidden ${activeTab === tab.id ? 'flex' : 'hidden'}`} key={tab.id}>
          <TabsDisplay activeTab={activeTab}/>
        </div>
      ))}
    </div>
  );
}
